export default __webpack_public_path__ + "static/media/HeartActive.1c9d311b.svg";